module.exports = __webpack_public_path__ + "img/20.f9fd7771.jpg";